import { Button, Checkbox, Form, message, Select, Spin } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';

import { fetchAPI } from '../../utils/api';

const DeleteProduct = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const countries = [
    { label: 'Singapore', value: 'SG' },
    { label: 'China', value: 'CN' },
    { label: 'Thailand', value: 'TH' },
    { label: 'India', value: 'IN' },
    { label: 'Vietnam', value: 'VN' },
    { label: 'Australia', value: 'AU' },
    { label: 'Malaysia', value: 'MY' },
    { label: 'Indonesia', value: 'ID' },
  ];
  const validateMessages = {
    required: 'This field is required!',
  };
  const handleSubmit = async payload => {
    const fullPayload = {
      ...payload,
      soft_delete: false,
      limit: 1000,
    };
    try {
      setLoading(true);
      await fetchAPI('product/purge_data', {
        payload: fullPayload,
        method: 'POST',
      });
      message.success('Products already deleted!');
    } catch (e) {
      // @ts-ignore
      message.error(`Failed to delete products: ${e}`);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Wrapper>
      <Spin spinning={loading}>
        <Form
          form={form}
          onFinish={handleSubmit}
          validateMessages={validateMessages}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 6 }}
        >
          <Form.Item
            name="regions"
            key={'countries'}
            label={'Countries'}
            rules={[{ required: true, message: 'Country is required' }]}
          >
            <Select
              style={{ width: '100%' }}
              mode="multiple"
              placeholder={'Select countries'}
              options={countries}
            />
          </Form.Item>
          <Form.Item
            name="data_to_purge"
            key={'data-to-purge'}
            label={'Data To Purge'}
            rules={[{ required: true, message: 'Data is required' }]}
          >
            <Checkbox.Group
              options={[
                { label: 'ES', value: 'ES' },
                { label: 'SA', value: 'SA' },
              ]}
            />
          </Form.Item>
          <Form.Item
            key={'delete-crawled-products'}
            label={'Delete Crawled Products'}
          >
            <Button type="primary" onClick={form.submit}>
              DELETE
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .top-bar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 20px;

    ul.ant-pagination {
      margin: 0px !important;
      margin-left: 20px !important;
    }
  }
`;
export default DeleteProduct;
